module.exports = __webpack_public_path__ + "0ff84d25bda9521fee9ea4f7ec4a4835.png";